import { render, staticRenderFns } from "./CardCategory.vue?vue&type=template&id=10a5279b"
import script from "./CardCategory.vue?vue&type=script&lang=js"
export * from "./CardCategory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports